/**
 * Shop name to a suggested URL handle.
 *
 * A display-only mirror of the backend's `slugify` (`store-ops.ts`), so the
 * merchant sees the address they are about to claim while typing rather than
 * after a round trip. The server re-derives and validates on claim and is the
 * authority — if the two ever disagree, the response's `slug` wins and is what
 * the UI shows.
 */
export function suggestShopSlug(name: string): string {
  return (
    name
      .normalize("NFKD")
      // Combining marks left behind by NFKD, so "Pokémon" becomes "pokemon"
      // rather than "pok-mon".
      .replace(/[̀-ͯ]/g, "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .slice(0, 40)
      .replace(/-+$/g, "")
  );
}

// Matches SHOP_SLUG_RE in the backend's store-profile.dto.ts. Kept here only to
// catch a bad handle before the request; the server rejects it either way.
const SHOP_SLUG_RE = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export function shopSlugError(slug: string): string | null {
  if (slug.length < 3) return "Use at least 3 characters.";
  if (slug.length > 40) return "Use 40 characters or fewer.";
  if (!SHOP_SLUG_RE.test(slug)) {
    return "Use lower-case letters, numbers and single hyphens.";
  }
  return null;
}
